import { motion } from "motion/react";
import { CHAPTERS } from "./chapters";
import { slides } from "./registry";

interface ProgressBarProps {
  index: number;
  onGoto: (index: number) => void;
}

export function ProgressBar({ index, onGoto }: ProgressBarProps) {
  const current = slides[index];
  const chapterStarts = CHAPTERS.map((chapter) => ({
    chapter,
    start: slides.findIndex((s) => s.chapter === chapter.number),
  })).filter(({ start }) => start !== -1);

  return (
    <div className="pointer-events-none absolute inset-x-0 bottom-0 z-30">
      <div className="flex items-end justify-between px-6 pb-3">
        <div className="pointer-events-auto flex items-center gap-2.5">
          {chapterStarts.map(({ chapter, start }) => {
            const isCurrent = current?.chapter === chapter.number;
            return (
              <button
                key={chapter.number}
                type="button"
                title={chapter.title}
                onClick={() => onGoto(start)}
                className="h-2.5 w-2.5 rounded-full transition-all duration-300"
                style={{
                  background: isCurrent
                    ? `linear-gradient(90deg, ${chapter.accent[0]}, ${chapter.accent[1]})`
                    : "rgba(255,255,255,0.2)",
                  boxShadow: isCurrent ? `0 0 12px ${chapter.accent[0]}` : "none",
                  transform: isCurrent ? "scale(1.4)" : "none",
                }}
              />
            );
          })}
        </div>
        <div className="font-mono text-base tabular-nums text-white/40">
          {index + 1} / {slides.length}
        </div>
      </div>
      <div className="h-0.5 bg-white/10">
        <motion.div
          className="h-full bg-linear-to-r from-accent-cyan via-accent-indigo to-accent-fuchsia"
          animate={{ width: `${((index + 1) / slides.length) * 100}%` }}
          transition={{ type: "spring", stiffness: 120, damping: 22 }}
        />
      </div>
    </div>
  );
}
